{
  "Active Contacts_DENTAL": "Active Patients",
  "Active Contacts_OPTOMETRY": "Active Patients",
  "Active Contacts_VET": "Active Clients",
  "Active Contacts_lastUsedVertical": "Active Contacts",
  "All Contacts_DENTAL": "All Patients",
  "All Contacts_OPTOMETRY": "All Patients",
  "All Contacts_VET": "All Clients",
  "All Contacts_lastUsedVertical": "All Contacts",
  "Contact_DENTAL": "Patient",
  "Contact_OPTOMETRY": "Patient",
  "Contact_VET": "Client",
  "Contact_lastUsedVertical": "Contact",
  "Contacts_DENTAL": "Patients",
  "Contacts_OPTOMETRY": "Patients",
  "Contacts_VET": "Clients",
  "Contacts_lastUsedVertical": "Contacts",
  "Delete Contact_DENTAL": "Delete Patient",
  "Delete Contact_OPTOMETRY": "Delete Patient",
  "Delete Contact_VET": "Delete Client",
  "Delete Contact_lastUsedVertical": "Delete Contact",
  "Edit Contact_DENTAL": "Edit Patient",
  "Edit Contact_OPTOMETRY": "Edit Patient",
  "Edit Contact_VET": "Edit Client",
  "Edit Contact_lastUsedVertical": "Edit Contact",
  "Household_DENTAL": "Household",
  "Household_OPTOMETRY": "Household",
  "Household_VET": "Patients",
  "Household_lastUsedVertical": "Contacts",
  "Inactive Contacts_DENTAL": "Inactive Patient",
  "Inactive Contacts_OPTOMETRY": "Inactive Patients",
  "Inactive Contacts_VET": "Inactive Clients",
  "Inactive Contacts_lastUsedVertical": "Inactive Contacts",
  "Individuals_DENTAL": "Individuals",
  "Individuals_OPTOMETRY": "Individuals",
  "Individuals_VET": "Individuals or pets",
  "Individuals_lastUsedVertical": "Individuals",
  "New Contact_lastUsedVertical": "New Contact",
  "Non-Patients_DENTAL": "Non-Patients",
  "Non-Patients_OPTOMETRY": "Non-Patients",
  "Non-Patients_VET": "Non-Clients",
  "Non-Patients_lastUsedVertical": "Non-Patients",
  "Operatories_DENTAL": "Operatories",
  "Operatories_OPTOMETRY": "Operatories",
  "Operatories_VET": "Operatories",
  "Operatories_lastUsedVertical": "Operatories",
  "Operatory_DENTAL": "Operatory",
  "Operatory_OPTOMETRY": "Operatory",
  "Operatory_VET": "Operatory",
  "Operatory_lastUsedVertical": "Operatory",
  "Patient_DENTAL": "Patient",
  "Patient_OPTOMETRY": "Patient",
  "Patient_VET": "Client",
  "Patient_lastUsedVertical": "Patient",
  "Patients_DENTAL": "Patients",
  "Patients_OPTOMETRY": "Patients",
  "Patients_VET": "Clients",
  "Patients_lastUsedVertical": "Patients",
  "non-patient_DENTAL": "non-patient",
  "non-patient_OPTOMETRY": "non-patient",
  "non-patient_VET": "non-client",
  "non-patient_lastUsedVertical": "non-patient",
  "patient's_DENTAL": "patient's",
  "patient's_OPTOMETRY": "patient's",
  "patient's_VET": "client's",
  "patient's_lastUsedVertical": "patient's",
  "patient_DENTAL": "patient",
  "patient_OPTOMETRY": "patient",
  "patient_VET": "client",
  "patient_lastUsedVertical": "patient",
  "patients'_DENTAL": "patients'",
  "patients'_OPTOMETRY": "patients'",
  "patients'_VET": "clients'",
  "patients'_lastUsedVertical": "patients'",
  "patients_DENTAL": "patients",
  "patients_OPTOMETRY": "patients",
  "patients_VET": "clients",
  "patients_lastUsedVertical": "patients"
}
